exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".story{background-color:#fff;background-image:-webkit-linear-gradient(top,#fefefe,#efefef,#fefefe,#fefefe,#fff);background-image:-moz-linear-gradient(top,#fefefe,#efefef,#fefefe,#fefefe,#fff);background-image:-o-linear-gradient(top,#fefefe,#efefef,#fefefe,#fefefe,#fff);background-image:linear-gradient(180deg,#fefefe,#efefef,#fefefe,#fefefe,#fff)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-162770b5","scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Stories.vue
// module id = 48
// module chunks = 0